function Dashboard(): JSX.Element {
  return <h1>Dashboard</h1>
}

export default Dashboard
